import { validate as uuidValidate } from 'uuid';

/**
 * Checks if a string is a valid UUID (any version).
 * Accepts UUIDv1, UUIDv3, UUIDv4, UUIDv5, etc.
 *
 * @param {string | null | undefined} uuid - The string to validate as a UUID.
 * @returns {boolean} - True if the string is a valid UUID, false otherwise.
 */
export const isUuid = (uuid: string | null | undefined): boolean => {
  if (!uuid || typeof uuid !== 'string') {
    return false;
  }
  return uuidValidate(uuid);
};
